import { ADMIN_BLOCK_ENDPOINT, ADMIN_DISTRICT_ENDPOINT, ADMIN_STATE_ENDPOINT, ADMIN_VILLAGE_ENDPOINT } from '../../../constants/constants';
import axiosInstance from '../api/apiInterceptor';
import { AxiosResponse } from 'axios';
import { State, District, Block, Village } from "../types/stateDistrict"



// State API calls
export const fetchStates = async (): Promise<State[]> => {
  try {
    const response: AxiosResponse<any> = await axiosInstance.get(`${ADMIN_STATE_ENDPOINT}?filter=&limit=100`);
    return response.data.data;
  } catch (error:any) {
    throw new Error(`Failed to fetch states: ${error.message}`);
  }
};

// Add State
export const addState = async (state: Omit<State, 'id'>): Promise<State> => {
  try {
    const response = await axiosInstance.post(`${ADMIN_STATE_ENDPOINT}`, state);
    return response.data;
  } catch (error:any) {
    throw new Error(`Failed to add state: ${error.message}`);
  }
};

// Update State
export const updateState = async (state: State): Promise<State> => {
  try {
    const response = await axiosInstance.patch(`${ADMIN_STATE_ENDPOINT}/${state.id}`, state);
    return response.data;
  } catch (error:any) {
    throw new Error(`Failed to update state: ${error.message}`);
  }
};

// District API calls
export const fetchDistricts = async (stateId?: number): Promise<District[]> => {
  try {
    const url = stateId ? `${ADMIN_DISTRICT_ENDPOINT}?filter=stateId|${stateId}&limit=100` : `${ADMIN_DISTRICT_ENDPOINT}`;
    const response = await axiosInstance.get(url);
    return response.data.data;
  } catch (error:any) {
    throw new Error(`Failed to fetch districts: ${error.message}`);
  }
};

// Add District
export const addDistrict = async (district: Omit<District, 'id'>): Promise<District> => {
  try {
    const response = await axiosInstance.post(`${ADMIN_DISTRICT_ENDPOINT}`, district);
    return response.data;
  } catch (error:any) {
    throw new Error(`Failed to add district: ${error.message}`);
  }
};

// Update District
export const updateDistrict = async (district: District): Promise<District> => {
  try {
    const response = await axiosInstance.patch(`${ADMIN_DISTRICT_ENDPOINT}/${district.id}`, district);
    return response.data;
  } catch (error:any) {
    throw new Error(`Failed to update district: ${error.message}`);
  }
};

// Delete District
export const deleteDistrict = async (id: number): Promise<number> => {
  try {
    await axiosInstance.delete(`${ADMIN_DISTRICT_ENDPOINT}/${id}`);
    return id;
  } catch (error:any) {
    throw new Error(`Failed to delete district: ${error.message}`);
  }
};

// Block API calls
export const fetchBlocks = async (stateId?:number,districtId?: number): Promise<Block[]> => {
  try {
    const url = districtId ? `${ADMIN_BLOCK_ENDPOINT}?filter=stateId|${stateId},districtId|${districtId}&limit=100` : `${ADMIN_BLOCK_ENDPOINT}`;
    const response = await axiosInstance.get(url);
    return response.data.data;
  } catch (error:any) {
    throw new Error(`Failed to fetch blocks: ${error.message}`);
  }
};

// Add Block
export const addBlock = async (block: Omit<Block, 'id'>): Promise<Block> => {
  try {
    const response = await axiosInstance.post(`${ADMIN_BLOCK_ENDPOINT}`, block);
    return response.data;
  } catch (error:any) {
    throw new Error(`Failed to add block: ${error.message}`);
  }
};

// Update Block
export const updateBlock = async (block: Block): Promise<Block> => {
  try {
    const response = await axiosInstance.patch(`${ADMIN_BLOCK_ENDPOINT}/${block.id}`, block);
    return response.data;
  } catch (error:any) {
    throw new Error(`Failed to update block: ${error.message}`);
  }
};

// Delete Block
export const deleteBlock = async (id: number): Promise<number> => {
  try {
    await axiosInstance.delete(`${ADMIN_BLOCK_ENDPOINT}/${id}`);
    return id;
  } catch (error:any) {
    throw new Error(`Failed to delete block: ${error.message}`);
  }
};



// Villages API Calls
export const fetchVillages = async (stateId?:number,districtId?: number,blockAreaId?: number): Promise<Village[]> => {
  try {
    const url = blockAreaId ? `${ ADMIN_VILLAGE_ENDPOINT }?filter=stateId|${stateId},districtId|${districtId},blockAreaId|${ blockAreaId }&limit=100` : `${ ADMIN_VILLAGE_ENDPOINT }`;
    const response = await axiosInstance.get(url);
    return response.data.data;
  } catch (error: any) {
    throw new Error(`Failed to fetch blocks: ${ error.message }`);
  }
};

// Add Block
export const addVillage = async (village: Omit<Village, 'id'>): Promise<Village> => {
  try {
    const response = await axiosInstance.post(`${ ADMIN_VILLAGE_ENDPOINT }`, village);
    return response.data;
  } catch (error: any) {
    throw new Error(`Failed to add block: ${ error.message }`);
  }
};

// Update Block
export const updateVillage = async (village: Village): Promise<Village> => {
  try {
    const response = await axiosInstance.patch(`${ ADMIN_VILLAGE_ENDPOINT }/${ village.id }`, village);
    return response.data;
  } catch (error: any) {
    throw new Error(`Failed to update block: ${ error.message }`);
  }
};

// Delete Block
export const deleteVillage = async (id: number): Promise<number> => {
  try {
    await axiosInstance.delete(`${ ADMIN_VILLAGE_ENDPOINT }/${ id }`);
    return id;
  } catch (error: any) {
    throw new Error(`Failed to delete block: ${ error.message }`);
  }

};

